export default class BlogMenu {
    static init() {
        const menu = document.querySelector('#blogCategory');

        if(menu) {
            menu.addEventListener('change', () => {
                window.location.href = menu.value;
            })
        }

    }
}
